import React, { Component } from "react";
import Error from "./../Common/Error";
import { validateSignInForm } from "../../Utils/Validator";
import { Link } from "react-router-dom";
import { getAuthCode, setSignupPath, unsetAuthCode } from "../../Services/StorageService";
import { activateEnterpriseBots } from "../../Services/BotsService";
import { updateLastLoggedInDomain } from "../../Services/UserService";
import {STATION_SATCOM_LANDING, THURAYA_LANDING, VIKAND_LANDING, VIKAND_DIRECT_LANDING, INTELL4DESK_LANDING, ONSHIP_LANDING, ONECARE_LANDING, ONECARE_PROD_URL_NEW, ONECARE_STAGE_URL, ONECARE_PROD_ANONYMOUS_USER_URL, ONECARE_STAGE_ANONYMOUS_USER_URL, ONECARE_DEV_ANONYMOUS_USER_URL, PIVOTEL_LANDING, STATION_ONE_LANDING, INTELSAT_LANDING, ONSHIP_NEW_STAGE2_URL} from '../../Utils/Constants';
import history from "./../../Services/History";
import "./Login.css";
import { loadAllDomainsListInLFStorage } from "../../Services/LFStorage";
import appType from "../../Utils/ApiConfig";
import { CircularProgress } from "@mui/material";
import { BUTTON_BACKGROUND_COLOR_STYLE } from "../../Utils/ColorPicker";
const HELPER_MESSAGE =
	"Please contact FrontM support. You have been logged in to default frontM domain";
const FRONTM_DOMAIN = "frontmai";
const ACTIVATE_ENTERPRISE_BOTS_ERROR_CODES = [
	"Invalid code",
	"Code has been already used by the user",
	"Code could not be applied. The code has expired or the maximum limit has been reached",
];

class FrontMLogin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: "",
			password: "",
			error: "",
			showPassword: false,
			showSpinner: false,
			corporateScreen:false
		};
	}

	componentDidMount() {
		if(this.props.corporateScreen){
			this.setState({corporateScreen:true})
			if(this.props.preFilledEmailValue){
				this.setState({email:this.props.preFilledEmailValue})
			}
		}
		
		if (this.props.error) {
			this.setState({ error: this.props.error });
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.error && this.props.error !== prevState.error) {
			this.setState({ error: this.props.error });
		}
	}

	stopSlideNavigation = () => {
		window.document.onkeydown = (e) => {
			e = e || window.event;
			switch (e.key) {
				case "ArrowLeft":
					break;
				case "ArrowRight":
					break;
				default:
			}
		};
	}

	startSlideNavigation = () => {
		window.document.onkeydown = (e) => {
			e = e || window.event;
			switch (e.key) {
				case "ArrowLeft":
					this.props.previous();
					break;
				case "ArrowRight":
					this.props.next();
					break;
				default:
			}
		};
	}

	modifyEmail = (e) => {
		e.stopPropagation();		
		let emailValue = e.target.value;
		this.setState({ email: emailValue });
		
		if(this.state.corporateScreen){
			this.props.preFillEmail(emailValue)
		}
		
	};
	modifyPassword = (e) => {
		e.stopPropagation();
		this.setState({ password: e.target.value });
	};

	handleErrorMsg = () => {
		setSignupPath(this.props.landingPath)
		if (this.state.error) {
			this.props.clearLoginError();
			this.props.removeUserLoginError();
			this.setState({ error: null });
		}
	};



	activateEnterpriseBotAndSetLastLoggedInDomain = (authCode) => {
		let message = null;
		return activateEnterpriseBots(authCode).then((activateResponse) => {
			let { content, error, errorMessage } = activateResponse;
			if (error !== 0 || content.length === 0) {
				message = errorMessage
					? errorMessage + ". " + HELPER_MESSAGE
					: HELPER_MESSAGE;
				return updateLastLoggedInDomain(FRONTM_DOMAIN).then(() => {
					if (message) {
						throw new Error(message);
					}
				});
			} else {
				const domains = content;
				let corporateDomainList = domains.filter((domain) => {
					return domain.userDomain !== FRONTM_DOMAIN;
				});
				loadAllDomainsListInLFStorage(corporateDomainList);
				let corporateDomain =
					corporateDomainList.length > 0
						? corporateDomainList[0].userDomain
						: "";
				if (corporateDomain.length === 0) {
					message = HELPER_MESSAGE;
					corporateDomain = FRONTM_DOMAIN;
				}
				return updateLastLoggedInDomain(corporateDomain).then(() => {
					if (message) {
						throw new Error();
					}
				});
			}
		});
	};

	doFrontMLogin = (e) => {
		e.preventDefault();
		this.setState({ showSpinner: true });
		let formData = {
			email: this.state.email,
			password: this.state.password,
		};
		let error = validateSignInForm(formData);
		if (error) {
			this.setState({
				error: error,
				showSpinner: false,
			});
			return;
		} else {
			const { email, password } = this.state;
			let newEmail = email.trim();
			let message = null;
			if (this.state.error) {
				this.setState({
					error: "",
					showSpinner: true,
				});
				this.props.removeUserLoginError();
			}
			console.log(`%c User ${newEmail} is login`, "color: green;");
			this.props.doFrontMLogin(newEmail, password, null, (error) => {
				if (error) {
					this.setState({ showSpinner: false });

					if (error === "Missing required parameter SOFTWARE_TOKEN_MFA_CODE") {
						history.push({
							pathname: "/otp",
							state: {
								newEmail,
								password,
							},
						});
						this.props.hideSpinner();
					} else this.props.onError(error, newEmail, password);
				} else {
					let authCodeObject = getAuthCode();
					let emailFromAuthCode =
						authCodeObject && Object.keys(authCodeObject)[0];
					let authCode = authCodeObject && authCodeObject[emailFromAuthCode];
					if (authCode && emailFromAuthCode === newEmail) {
						this.activateEnterpriseBotAndSetLastLoggedInDomain(authCode)
							.then(() => {
								this.props.onLogin();
							})
							.catch((err) => {
								// this.setState({ showSpinner: false });

								console.error(
									"error on activateEnterpriseBotAndSetLastLoggedInDomain login :: :: :: ::",
									err
								);
								let errMsg = err ? err.message : "";
								if (
									errMsg &&
									ACTIVATE_ENTERPRISE_BOTS_ERROR_CODES.indexOf(errMsg) !== -1
								) {
									message = errMsg + ". " + HELPER_MESSAGE;
								} else {
									message = HELPER_MESSAGE;
								}
								this.setState({ error: message });
							})
							.finally(() => {
								this.props.onLogin(message); //(message);
							});
					} else {
						this.setState({ error: null });
						this.props.onLogin();
					}
				}
			});
		}
	};

	handleAnonymousUser = () => {
		const redirectURL =
			window.location.hostname === ONECARE_PROD_URL_NEW
				? ONECARE_PROD_ANONYMOUS_USER_URL
				: window.location.hostname === ONECARE_STAGE_URL
					? ONECARE_STAGE_ANONYMOUS_USER_URL
					: ONECARE_DEV_ANONYMOUS_USER_URL;
		if (redirectURL) history.push(redirectURL);
	};

	render() {
		let { email, password, error, showSpinner } = this.state;
		let { landingPath } = this.props;
		let marginBottomLabel = "-0.1rem"
		let labelFontWeight = "normal"
		let labelColor = "#666666"
		let labelFontSize = ""
		let forgotPassText =
			landingPath === ONSHIP_LANDING
				? "Forgot password ?"
				: "Forgot Password ?";
		let marginTopForgotPass =  landingPath === ONSHIP_LANDING || landingPath === STATION_ONE_LANDING ? "-1rem" : "0rem";

		let emailPlaceHolder = landingPath === ONSHIP_LANDING ? "email@example.com" : "Email";
		if (landingPath == ONECARE_LANDING) {
			emailPlaceHolder = "User name or email";
		}
		let passwordPlaceHolder = landingPath === ONSHIP_LANDING ? "" : "......";
		let isCorporateCustomStyle = false;
		let isIntelsatCustomStyle = false;

		let eyeIconStyles = {
				fontSize: "16px",
				color: "#d5d5d5",
				position: "absolute",
				right: "10px",
				bottom: landingPath === PIVOTEL_LANDING || landingPath === INTELSAT_LANDING? "6px":"10px",
				cursor: "pointer",
		}
		let marginTopLogin = "0px"

		const corporateCustomStyles = {
			customInput:{
				border:"none",
				borderRadius:"2px",
				backgroundColor:"#f4f7fb",
				fontSize:"12px",
				fontWeight:"normal",
				color:"#66bfbf !important",
				
			},
			customForgotPassword:{
				marginLeft:"-12px",
				fontSize:"12px",
				textDecoration:"underline",
			},
			gapBetweenFields:{
				marginBottom:"15px"
			}
		}

		const intelsatCustomStyles = {
			customInput:{
				border:"none",
				borderRadius:"6px",
				backgroundColor:"#69B3E733",
				fontSize:"12px",
				fontWeight:"normal",
				color:"#66bfbf !important",
				
			},
			customForgotPassword:{
				marginLeft:"-12px",
				fontSize:"12px",
				textDecoration:"underline",
			},
			gapBetweenFields:{
				marginBottom:"15px"
			}
		}

		error =
			error && error == "Network Error"
				? [
					"Server cannot be reached. Please verify access checking ",
					<a href="status" target="_blank">
						this link
					</a>,
				]
				: error;
		

		if(landingPath === PIVOTEL_LANDING){
			labelFontWeight = "500"
			labelColor = "black"
			labelFontSize = "12px"
			emailPlaceHolder = "Enter email address"
			passwordPlaceHolder = "Enter password"
			marginTopForgotPass= "-17px"
			isCorporateCustomStyle = true
			marginBottomLabel = "0.1rem"
		}
		
		if(landingPath === INTELSAT_LANDING){
			labelFontWeight = "300"
			labelColor = "#4A4A4A"
			labelFontSize = "12px"
			emailPlaceHolder = "email@example.com"
			passwordPlaceHolder = "enter your password"
			marginTopForgotPass= "-17px"
			isIntelsatCustomStyle = true
			marginBottomLabel = "0.1rem"
		}

		return (
			<div>
				<div className="error-container">
					{error && <Error message={error} />}
				</div>
				<form role="form" onSubmit={this.doFrontMLogin} noValidate>
					<div className="form-group">
						{(landingPath === THURAYA_LANDING ||
							landingPath === STATION_SATCOM_LANDING ||
							landingPath === VIKAND_LANDING ||
							landingPath === VIKAND_DIRECT_LANDING ||
							landingPath === ONSHIP_LANDING ||
							landingPath === INTELL4DESK_LANDING ||
							landingPath === PIVOTEL_LANDING || 
							landingPath === STATION_ONE_LANDING ||
							landingPath === INTELSAT_LANDING ||
							([ONSHIP_NEW_STAGE2_URL].includes(window.location.hostname) && window.location.pathname === VIKAND_LANDING)
						) && (
								<label style={{ color:labelColor, fontSize:labelFontSize , fontWeight:labelFontWeight , marginBottom: marginBottomLabel, ...landingPath === ONSHIP_LANDING && { fontFamily: "Figtree-Regular" }  }}>
									Email
								</label>
							)}
						<input
							placeholder={emailPlaceHolder}
							type="email"
							className="form-control form-content-input"
							style = {isCorporateCustomStyle ? corporateCustomStyles.customInput : isIntelsatCustomStyle ? intelsatCustomStyles.customInput : {}}
							onChange={this.modifyEmail}
							value={email}
							onFocus={() => this.state.corporateScreen && this.stopSlideNavigation()}
							onBlur={() => this.state.corporateScreen && this.startSlideNavigation()}
							autoComplete="username"
						/>
					</div>
					
					{isCorporateCustomStyle && 
						<div style={corporateCustomStyles.gapBetweenFields}></div>
					}

					<div
						className="form-group d-flex flex-column align-items-start"
						style={{ position: "relative" }}
					>
						{(landingPath === THURAYA_LANDING ||
							landingPath === STATION_SATCOM_LANDING ||
							landingPath === VIKAND_LANDING ||
							landingPath === VIKAND_DIRECT_LANDING ||
							landingPath === INTELL4DESK_LANDING ||
							landingPath === ONSHIP_LANDING ||
							landingPath === PIVOTEL_LANDING ||
							landingPath === STATION_ONE_LANDING ||
							landingPath === INTELSAT_LANDING || 
							([ONSHIP_NEW_STAGE2_URL].includes(window.location.hostname) && window.location.pathname === VIKAND_LANDING)
						) && (
								<label style={{ color:labelColor, fontSize:labelFontSize , fontWeight:labelFontWeight, marginBottom: marginBottomLabel, ...landingPath === ONSHIP_LANDING && { fontFamily: "Figtree-Regular" } }}>
									Password
								</label>
							)}
						<input
							placeholder={passwordPlaceHolder}
							type={this.state.showPassword ? "text" : "password"}
							className="form-control form-content-input"
							style= {isCorporateCustomStyle ? corporateCustomStyles.customInput : isIntelsatCustomStyle ? intelsatCustomStyles.customInput : {}}
							onChange={this.modifyPassword}
							autoComplete="current-password"
							value={password}
							onFocus={() => this.state.corporateScreen && this.stopSlideNavigation()}
							onBlur={() => this.state.corporateScreen && this.startSlideNavigation()}
						/>
						{this.state.showPassword ? (
							<i
								className="fa fa-eye"
								onClick={() =>
									this.setState({ showPassword: !this.state.showPassword })
								}
								style={eyeIconStyles}
							/>
						) : (
							<i
								className="fa fa-eye-slash"
								onClick={() =>
									this.setState({
										showPassword: !this.state.showPassword,
									})
								}
								style={eyeIconStyles}
							/>
						)}
						{showSpinner && (
							<div
								style={{
									position: "absolute",
									right: "-30px",
									bottom: "-2px",
								}}
							>
								<CircularProgress
									size="3vh"
									thickness={1.2}
									color="secondary"
								/>
							</div>
						)}
					</div>

					<Link
						to="/resetPassword"
						onClick={() => this.handleErrorMsg()}
						className={`btn btn-text mb-20 ${landingPath && landingPath.replace("/", "")
							}-txt`}
						style={Object.assign({marginTop: marginTopForgotPass} , isCorporateCustomStyle && corporateCustomStyles.customForgotPassword) } 
					>
						{forgotPassText}
					</Link>

					<button
						type="submit"
						style={{...BUTTON_BACKGROUND_COLOR_STYLE , ...{marginTop:marginTopLogin}}}
						className={`btn btn-open btn-block btn-icon ${landingPath && landingPath.replace("/", "")
							}-btn`}
					>
						Log in
					</button>
					{landingPath === ONECARE_LANDING && (
						<div className="d-flex justify-content-center mt-20 mb-20">
							<div
								onClick={this.handleAnonymousUser}
								className={`btn btn-text ${landingPath && landingPath.replace("/", "")
									}-txt`}
							>
								{"OneCare Registration Form"}
							</div>
						</div>
					)}
				</form>
			</div>
		);
	}
}

export default FrontMLogin;
